import { render, staticRenderFns } from "./EditTrip.vue?vue&type=template&id=c4f1586c&"
import script from "./EditTrip.vue?vue&type=script&lang=js&"
export * from "./EditTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports